import defaultState from './state'
import mutations from './mutations'
import actions from './actions'

const reservation = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations,
  actions,
}

export default reservation



// WEBPACK FOOTER //
// ./src/store/reservation/index.js